import { render } from "./GenreComponent.vue?vue&type=template&id=04eafe7e"
import script from "./GenreComponent.vue?vue&type=script&lang=js"
export * from "./GenreComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__